import Template from '@/shared/app/model/templating/Template';
import Dataset from '@/shared/data/model/Dataset';
import { isArray } from 'lodash';
import { CommunicationsDataset } from '../types';

type Zone =
  | 'accueil_1'
  | 'accueil_2'
  | 'accueil_3'
  | 'accueil_4'
  | 'distribution_1'
  | 'distribution_2'
  | 'distribution_3'
  | 'distribution_4'
  | 'caisses_1'
  | 'caisses_2';

type UniCommunicationsMakerArgs = {
  mask?: {
    backgroundColor?: string;
    backgroundImage?: string;
    opacity?: number;
    backgroundSize?: string;
    backgroundPosition?: string;
  };
  zones?: Zone | Zone[] | string[];
  mode?: string;
  uploadsBaseUrl?: string;
  playMode?: 'loop' | 'once';
  doneEvent?: string;
  overrideDataset?: CommunicationsDataset;
};

export const makeUniCommunications = (args: UniCommunicationsMakerArgs): Template => {
  const config: Dataset = {
    maskBackgroundColor: args.mask?.backgroundColor ?? 'black',
    maskOpacity: args.mask?.opacity ?? 1,
    maskBackgroundSize: args.mask?.backgroundSize ?? 'cover',
    maskBackgroundPosition: args.mask?.backgroundPosition ?? 'center',
  };
  if (args.mask?.backgroundImage) config.maskBackgroundImage = args.mask.backgroundImage;
  if (args.uploadsBaseUrl) config.uploadsBaseUrl = args.uploadsBaseUrl;
  if (args.zones?.length)
    if (isArray(args.zones)) config.myZones = args.zones.join(',');
    else config.myZones = args.zones;
  if (args.mode) config.mode = args.mode;
  if (args.playMode) config.playMode = args.playMode;
  if (args.doneEvent) config.doneEvent = args.doneEvent;

  const template: Template = {
    component: 'Communications',
    config,
    slots: {},
  };

  if (args.overrideDataset)
    template.datasets = {
      overrideCommunications: args.overrideDataset as Dataset,
    };

  return template;
};
